export default {
    apiosticket: process.env.VUE_APP_API_OSTICKET,
    apikeyosticket: process.env.VUE_APP_APIKEY_OSTICKET,
    test: process.env.VUE_APP_API_TEST,
    fileupload: process.env.VUE_APP_API_FILEUPLOAD,
    alumnos: process.env.VUE_APP_API_ALUMNOS,
    auth: process.env.VUE_APP_API_AUTH,
    cdn: process.env.VUE_APP_CDN
};